import React, { useEffect, useMemo, useRef, useState} from 'react';
import {useAuth} from '../../contexts/auth';
import notify from "devextreme/ui/notify";
import {Popup} from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import Form, {
    ButtonItem,
    ButtonOptions,
    GroupItem,
    Item,
    Label
} from 'devextreme-react/form';
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";

const PopupRefreshOldPeriod = ({setVisibleRefreshOldPeriodPopupFun}) => {
    // let visible = props.visible
    // let setVisibleRefreshOldPeriodPopupFun = props.setVisibleRefreshOldPeriodPopupFun
    const {syncUserData, dogovors, selectedDog, loadSyncUser, syncInFlight} = useAuth()
    const formData = useRef({})
    const [isAdmin, setIsAdmin] = useState(false);
    const [yearArray, setYearArray] = useState([]);
    const [yearS, setYearS] = useState('');
    const [yearPo, setYearPo] = useState('');
    const [monthS, setMonthS] = useState('');
    const [monthPo, setMonthPo] = useState('');
    const [monthArrayS, setMonthArrayS] = useState([]);
    const [monthArrayPo, setMonthArrayPo] = useState([]);
    //const [periods, setPeriods] = useState([null, null]);
    const [datePoMax, setDatePoMax] = useState(new Date());

    const allMonthArray = useMemo(() => [
        {name: 'январь', val: '01'},
        {name: 'февраль', val: '02'},
        {name: 'март', val: '03'},
        {name: 'апрель', val: '04'},
        {name: 'май', val: '05'},
        {name: 'июнь', val: '06'},
        {name: 'июль', val: '07'},
        {name: 'август', val: '08'},
        {name: 'сентябрь', val: '09'},
        {name: 'октябрь', val: '10'},
        {name: 'ноябрь', val: '11'},
        {name: 'декабрь', val: '12'},
    ], []);

    useEffect(() => {
        const dogs = dogovors.filter(dog => dog.kodDog === selectedDog?.kodDog);
        if (dogs.length > 0 && dogs[0].roles.includes(1)) {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
    }, [dogovors, selectedDog])

    useEffect(() => {
        const prevDate = new Date();
        prevDate.setDate(1);
        prevDate.setMonth(prevDate.getMonth() + 2);
        setDatePoMax(new Date(prevDate.getFullYear(), prevDate.getMonth(), 1));
    }, [])

    useEffect(() => {
        const years = [];
        const maxYear = datePoMax.getFullYear();
        for (let i = 2000; i <= maxYear; i++) {
            years.push(i.toString());
        }
        setYearArray(years);

        const currDate = new Date();
        setYearS(currDate.getFullYear().toString());
        setYearPo(currDate.getFullYear().toString());
        setMonthArrayS(allMonthArray);
        setMonthArrayPo(allMonthArray);
        setMonthS((currDate.getMonth() + 1).toString().padStart(2, '0'));
        setMonthPo((currDate.getMonth() + 1).toString().padStart(2, '0'));
    }, [datePoMax, allMonthArray]);


    const refreshData = async (per1,per2) => {
        const res = await syncUserData(per1, per2);
        // возвращается только положительный результат
        if (res.isOk) {
            const already = res.message && res.message.indexOf('уже запущена') !== -1;
            notify(res.message, already ? 'warning' : 'success', 10000);
            return true;
        }
        return false;
    }

    const yearSOptions = {
        dataSource: yearArray,
        value: yearS,
        placeholder: "Выберите год",
        onValueChanged: (e) => {
            setYearS(e.value);
            if (yearArray.indexOf(e.value) === (yearArray.length - 1)) {
                setMonthArrayS(allMonthArray.filter(el => Number(el.val) <= (datePoMax.getMonth() + 1)))
            } else {
                setMonthArrayS(allMonthArray)
            }
            if (monthArrayS.filter(el => el.val === monthS).length === 0) {
                setMonthS(null);
            }
        }
    }
    const yearPoOptions = {
        dataSource: yearArray,
        value: yearPo,
        placeholder: "Выберите год",
        onValueChanged: (e) => {
            setYearPo(e.value);
            if (yearArray.indexOf(e.value) === (yearArray.length - 1)) {
                setMonthArrayPo(allMonthArray.filter(el => Number(el.val) <= (datePoMax.getMonth() + 1)))
            } else {
                setMonthArrayPo(allMonthArray)
            }
            if (monthArrayPo.filter(el => el.val === monthPo).length === 0) {
                setMonthPo(null);
            }
        }
    }

    const monthSOptions = {
        dataSource: monthArrayS,
        displayExpr: "name",
        valueExpr: "val",
        value: monthS,
        placeholder: "Выберите месяц",
        onValueChanged: (e) => {
            setMonthS(e.value)
        }
    }
    const monthPoOptions = {
        dataSource: monthArrayPo,
        displayExpr: "name",
        valueExpr: "val",
        value: monthPo,
        placeholder: "Выберите месяц",
        onValueChanged: (e) => {
            setMonthPo(e.value)
        }
    }

    const onSendRequest = async (e) => {
        e.preventDefault();
        const { year_s, month_s, year_po, month_po } = formData.current;
        if (!year_s || !month_s) {
            if (isAdmin) {
                notify('Выберите "Период С"', 'error', 5000);
            } else {
                notify('Вы не выбрали период!', 'error', 5000);
            }
            return;
        }
        if (isAdmin && (!year_po || !month_po)) {
            notify('Выберите "Период ПО"', 'error', 5000);
            return;
        }
        const period_s = Number(year_s + '.' + month_s);
        let period_po;
        let defaultFormValues;
        const nowYear = new Date().getFullYear().toString();
        const nowMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
        if (year_po && month_po) {
            period_po = Number(year_po + '.' + month_po);
            defaultFormValues = {
                year_s: nowYear,
                year_po: nowYear,
                month_s: nowMonth,
                month_po: nowMonth
            }
        } else {
            period_po = period_s;
            defaultFormValues = {
                year_s: nowYear,
                month_s: nowMonth
            }
        }
        if (period_po < period_s) {
            notify('"Период по" не может быть меньше "Периода с"!', 'error', 5000);
            return;
        }
        //setPeriods([period_s, period_po]);
        const res = await refreshData(period_s, period_po);
        if (res) {
            formData.current = defaultFormValues;
            setYearS(nowYear)
            setYearPo(nowYear)
            setMonthS(nowMonth)
            setMonthPo(nowMonth)
            setVisibleRefreshOldPeriodPopupFun(false);
        }
    }


    return (
        <>
           <Popup
                    id="help-popup"
                    visible={true}
                    onHiding={()=>setVisibleRefreshOldPeriodPopupFun(false)}
                    hideOnOutsideClick={true}
                    height='auto'
                    maxHeight="800px" //форма с прибором не входит никак иначе
                    maxWidth="800px"
                    title={`Обновление данных по договору №${selectedDog?.ndog}`}
                    showCloseButton={true}
                    titleRender={()=>PopupTitleWithIcon(faRefresh, `Обновление данных по договору №${selectedDog?.ndog}`,()=>setVisibleRefreshOldPeriodPopupFun(false))}
                >
                <ScrollView className="big-input popupWithUploader" width='100%' height='100%'>
                    <form className="px-3" onSubmit={onSendRequest}>
                        <Form labelMode={'floating'}
                              labelLocation={'top'}
                              formData={formData.current}
                              id="req-dog-data-popup-form"
                              colCount={1}
                        >
                            {isAdmin ? (
                                <GroupItem>
                                    <Item><h4>Выберите периоды для обновления данных</h4></Item>
                                    <GroupItem colCount={2}>
                                        <GroupItem colCount={1}>
                                            <Item><h5>Период с</h5></Item>
                                            <GroupItem colCount={2}>
                                                <Item dataField="year_s" editorType="dxSelectBox" editorOptions={yearSOptions}>
                                                    <Label text={"Год"}/>
                                                </Item>
                                                <Item dataField="month_s" editorType="dxSelectBox" editorOptions={monthSOptions}>
                                                    <Label text={"Месяц"}/>
                                                </Item>
                                            </GroupItem>
                                        </GroupItem>
                                        <GroupItem colCount={1}>
                                            <Item><h5>Период по</h5></Item>
                                            <GroupItem colCount={2}>
                                                <Item dataField="year_po" editorType="dxSelectBox" editorOptions={yearPoOptions}>
                                                    <Label text={"Год"}/>
                                                </Item>
                                                <Item dataField="month_po" editorType="dxSelectBox" editorOptions={monthPoOptions}>
                                                    <Label text={"Месяц"}/>
                                                </Item>
                                            </GroupItem>
                                        </GroupItem>
                                    </GroupItem>
                                </GroupItem>
                            ) : (
                                <GroupItem>
                                    <Item><h4>Выберите период, за который будут обновлены данные</h4></Item>
                                    <GroupItem colCount={2}>
                                        <Item dataField="year_s" editorType="dxSelectBox" editorOptions={yearSOptions}>
                                            <Label text={"Год"}/>
                                        </Item>
                                        <Item dataField="month_s" editorType="dxSelectBox" editorOptions={monthSOptions}>
                                            <Label text={"Месяц"}/>
                                        </Item>
                                    </GroupItem>
                                </GroupItem>
                            )}
                            <ButtonItem horizontalAlignment="right">
                                <ButtonOptions
                                    type={'default'}
                                    useSubmitBehavior={true}
                                    text={loadSyncUser || syncInFlight
                                        ? 'Синхронизация уже запущена'
                                        : 'Обновить данные договора'}
                                    icon={loadSyncUser || syncInFlight ? undefined : 'refresh'}
                                    disabled={!!(loadSyncUser || syncInFlight)}
                                >
                                </ButtonOptions>
                            </ButtonItem>
                        </Form>
                    </form>
                </ScrollView>
            </Popup>

        </>
    )
}

export default PopupRefreshOldPeriod
